import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { GridHeaderFilterModule } from '@portal-core/ui/grid/components/grid-header-filter/grid-header-filter.module';
import { GridHeaderFilterFormModule } from '@portal-core/ui/grid/directives/grid-header-filter-form/grid-header-filter-form.module';
import { GridHeaderFilterMenuModule } from '@portal-core/ui/grid/directives/grid-header-filter-menu/grid-header-filter-menu.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { GridStringFilterComponent } from './grid-string-filter.component';

@NgModule({
  imports: [
    McColorModule,
    CommonModule,
    FormsModule,
    GridHeaderFilterFormModule,
    GridHeaderFilterMenuModule,
    GridHeaderFilterModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule
  ],
  declarations: [
    GridStringFilterComponent
  ],
  exports: [
    GridStringFilterComponent
  ]
})
export class GridStringFilterModule { }
